import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import h, { popoverBaseProps as m } from "../../popover/src/Popover.js";
import { popselectInjectionKey as g } from "./interface.js";
import b, { panelProps as P, panelPropKeys as c } from "./PopselectPanel.js";
import O from "../../_mixins/use-config.js";
import u from "../../_mixins/use-theme.js";
import { keep as _ } from "../../_utils/vue/keep.js";
import { createRefSetter as j } from "../../_utils/vue/create-ref-setter.js";
import { mergeEventHandlers as d } from "../../_utils/vue/merge-handlers.js";
import { omit as f } from "../../_utils/vue/omit.js";
import y from "../styles/light.js";
import { defineComponent as R, provide as $, h as v } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as M } from "../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
const w = Object.assign(Object.assign(Object.assign(Object.assign({}, u.props), f(m, ["showArrow", "arrow"])), {
  placement: Object.assign(Object.assign({}, m.placement), {
    default: "bottom"
  }),
  trigger: {
    type: String,
    default: "hover"
  }
}), P), L = R({
  name: "Popselect",
  props: w,
  slots: Object,
  inheritAttrs: !1,
  __popover__: !0,
  setup(n) {
    const {
      mergedClsPrefixRef: a
    } = O(n), s = u("Popselect", "-popselect", void 0, y, n, a), r = M(null);
    function i() {
      var o;
      (o = r.value) === null || o === void 0 || o.syncPosition();
    }
    function p(o) {
      var e;
      (e = r.value) === null || e === void 0 || e.setShow(o);
    }
    return $(g, {
      props: n,
      mergedThemeRef: s,
      syncPosition: i,
      setShow: p
    }), Object.assign(Object.assign({}, {
      syncPosition: i,
      setShow: p
    }), {
      popoverInstRef: r,
      mergedTheme: s
    });
  },
  render() {
    const {
      mergedTheme: n
    } = this, a = {
      theme: n.peers.Popover,
      themeOverrides: n.peerOverrides.Popover,
      builtinThemeOverrides: {
        padding: "0"
      },
      ref: "popoverInstRef",
      internalRenderBody: (s, r, i, p, l) => {
        const {
          $attrs: o
        } = this;
        return v(b, Object.assign({}, o, {
          class: [o.class, s],
          style: [o.style, ...i]
        }, _(this.$props, c), {
          ref: j(r),
          onMouseenter: d([p, o.onMouseenter]),
          onMouseleave: d([l, o.onMouseleave])
        }), {
          header: () => {
            var e, t;
            return (t = (e = this.$slots).header) === null || t === void 0 ? void 0 : t.call(e);
          },
          action: () => {
            var e, t;
            return (t = (e = this.$slots).action) === null || t === void 0 ? void 0 : t.call(e);
          },
          empty: () => {
            var e, t;
            return (t = (e = this.$slots).empty) === null || t === void 0 ? void 0 : t.call(e);
          }
        });
      }
    };
    return v(h, Object.assign({}, f(this.$props, c), a, {
      internalDeactivateImmediately: !0
    }), {
      trigger: () => {
        var s, r;
        return (r = (s = this.$slots).default) === null || r === void 0 ? void 0 : r.call(s);
      }
    });
  }
});
export {
  L as default,
  w as popselectProps
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/popselect/src/Popselect.js
// module id = 1682
// module chunks = 41